import { useState } from 'react'
import AdminLayout from '../components/AdminLayout'
import ProductsTable from './components/ProductsTable'
import OrdersTable from './components/OrdersTable'
import CategoriesManager from './components/CategoriesManager'

const TABS = [
  { id: 'products', label: 'Products' },
  { id: 'orders', label: 'Orders' },
  { id: 'categories', label: 'Categories' },
]

export default function AdminShop() {
  const [activeTab, setActiveTab] = useState('products')

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8">
        <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
          Shop
        </h1>
        <p className="text-gray-500 text-sm">Manage products, orders, and categories</p>
      </div>

      {/* Tab Bar */}
      <div className="flex gap-0 border-b border-gray-200 dark:border-white/10 mb-6 overflow-x-auto">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-5 py-3 text-xs font-bold uppercase tracking-widest whitespace-nowrap transition-colors border-b-2 -mb-px ${
              activeTab === tab.id
                ? 'border-green-600 text-green-600 dark:text-green-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'products' && <ProductsTable />}
      {activeTab === 'orders' && <OrdersTable />}
      {activeTab === 'categories' && <CategoriesManager />}
    </AdminLayout>
  )
}